import { appWithTranslation } from 'next-i18next'
import { Lato } from 'next/font/google'
import { AuthContextProvider } from '@/contexts/useAuth'
import NextNProgress from 'nextjs-progressbar'
import type { AppProps } from 'next/app'

import { instance } from '@/lib/http/axios'

import '@/styles/globals.scss'
import { ReactElement, ReactNode } from 'react'
import { NextPage } from 'next'
import Layout from '@/components/layout/Layout'
import { Toaster } from '@/components/ui/toaster'
import Head from 'next/head'

const font = Lato({
  weight: ['100', '300', '400', '900', '700'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
})

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

function App({ Component, pageProps: { ...pageProps } }: AppPropsWithLayout) {
  instance.defaults.headers.common['Accept-Language'] =
    pageProps._nextI18Next?.initialLocale ?? 'en'

  const getLayout = Component.getLayout ?? ((page) => <Layout>{page}</Layout>)

  return (
    <div className={font.className}>
      <Head>
        <title>Aloesuite</title>
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "s983huzekm");`,
          }}
        />
      </Head>

      <AuthContextProvider>
        <NextNProgress color="#004225" height={2} />

        {getLayout(<Component {...pageProps} />)}

        <Toaster />
      </AuthContextProvider>
    </div>
  )
}

export default appWithTranslation(App)
